import { ACTIONS } from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouteDefinition[]} */
const nursingRoutes = [
    {
        action: ACTIONS.BOWEL_EVAL_GLOBAL_LIST,
        component: () => import("./BowelEval/List/BowelEvalsList.svelte")
    },
    {
        action: ACTIONS.BOWEL_EVAL_MANAGE,
        component: () => import("./BowelEval/Form/BowelEvalForm.svelte")
    },
    {
        action: ACTIONS.BRADEN_SCALE_MANAGE,
        component: () => import("./BradenScale/Form/BradenScaleForm.svelte")
    },
    {
        action: ACTIONS.BRADEN_SCALE_GLOBAL_LIST,
        component: () => import("./BradenScale/List/BradenScalesList.svelte")
    },
    {
        action: ACTIONS.CLINICAL_REVIEW_GLOBAL_LIST,
        component: () => import("./ExpandedClinicalReview/List/ExpandedClinicalReviewsList.svelte")
    },
    {
        action: ACTIONS.CLINICAL_REVIEW_MANAGE,
        component: () => import("./ExpandedClinicalReview/Form/ExpandedClinicalReviewForm.svelte")
    },
    {
        action: ACTIONS.CLINICAL_REVIEW_POA_GLOBAL_LIST,
        component: () => import("./ExpandedClinicalReviewPlanOfAction/List/ExpandedClinicalReviewPlanOfActionList.svelte")
    },
    {
        action: ACTIONS.CLINICAL_REVIEW_POA_MANAGE,
        component: () => import("./ExpandedClinicalReviewPlanOfAction/Form/ExpandedClinicalReviewPlanOfActionForm.svelte")
    },
    {
        action: ACTIONS.FALL_RISK_ASSESSMENT_MANAGE,
        component: () => import("./FallRiskAssessment/Form/FallRiskAssessmentForm.svelte")
    },
    {
        action: ACTIONS.FALL_RISK_ASSESSMENT_GLOBAL_LIST,
        component: () => import("./FallRiskAssessment/List/FallRiskAssessmentsList.svelte")
    },
    {
        action: ACTIONS.HEALTHCARE_PLAN_GLOBAL_LIST,
        component: () => import("./HealthcarePlans/List/HealthcarePlansList.svelte")
    },
    {
        action: ACTIONS.HEALTHCARE_PLAN_MANAGE,
        component: () => import("./HealthcarePlans/Form/HealthcarePlanForm.svelte")
    },
    {
        action: ACTIONS.NURSING_DELEGATION_GLOBAL_LIST,
        component: () => import("./NursingDelegations/List/NursingDelegationsList.svelte")

    },
    {
        action: ACTIONS.SAMA_MANAGE,
        component: () => import("./SelfAdministrationOfMedicationAssessments/Form/SelfAdministrationOfMedicationAssessmentForm.svelte")
    },
    {
        action: ACTIONS.SAMA_GLOBAL_LIST,
        component: () => import("./SelfAdministrationOfMedicationAssessments/List/SelfAdministrationOfMedicationAssessmentsList.svelte")
    },
    {
        action: ACTIONS.CHECKLISTS_SAM_MANAGE,
        component: () => import("./SelfAdministrationOfMedication/Form/SelfAdministrationOfMedicationForm.svelte")
    },
    {
        action: ACTIONS.CHECKLISTS_SAM_GLOBAL_LIST,
        component: () => import("./SelfAdministrationOfMedication/List/SelfAdministrationOfMedicationList.svelte")
    },
    {
        action: ACTIONS.CHECKLISTS_SCIPR_GLOBAL_LIST,
        component: () => import("./SciprNursingReviews/List/SciprNursingReviewsList.svelte")
    },
    {
        action: ACTIONS.CHECKLISTS_SCIPR_MANAGE,
        component: () => import("./SciprNursingReviews/Form/SciprNursingReviewForm.svelte")
    },
    {
        action: ACTIONS.CHECKLISTS_SMM_MANAGE,
        component: () => import("./SelfManagementOfMedication/Form/SelfManagementOfMedicationForm.svelte")
    },
    {
        action: ACTIONS.CHECKLISTS_SMM_GLOBAL_LIST,
        component: () => import("./SelfManagementOfMedication/List/SelfManagementOfMedicationList.svelte")
    },
    {
        action: ACTIONS.CHECKLISTS_TD_RATINGS_MANAGE,
        component: () => import("./TardiveDyskinesiaRatingScales/Form/TardiveDyskinesiaRatingScaleForm.svelte")
    },
    {
        action: ACTIONS.CHECKLISTS_TD_RATINGS_GLOBAL_LIST,
        component: () => import("./TardiveDyskinesiaRatingScales/List/TardiveDyskinesiaRatingScalesList.svelte")
    },
    {
        action: ACTIONS.CHECKLISTS_PCNR_MANAGE,
        component: () => import("./PersonCenteredNursingReviews/Form/PersonCenteredNursingReviewForm.svelte")
    },
    {
        action: ACTIONS.CHECKLISTS_PCNR_GLOBAL_LIST,
        component: () => import("./PersonCenteredNursingReviews/List/PersonCenteredNursingReviewsList.svelte")
    },
    {
        action: ACTIONS.RN_OVERSIGHT_GLOBAL_LIST,
        component: () => import("./RnOversightForms/List/RnOversightFormList.svelte")
    },
    {
        action: ACTIONS.RN_OVERSIGHT_MANAGE,
        component: () => import("./RnOversightForms/Form/RnOversightForm.svelte")
    },
    {
        action: ACTIONS.TEMP_PONS_GLOBAL_LIST,
        component: () => import("./TempPlansOfNursingServices/List/TempPlansOfNursingServicesList.svelte")
    },
    {
        action: ACTIONS.TEMP_PONS_MANAGE,
        component: () => import("./TempPlansOfNursingServices/Form/TempPlanOfNursingServicesForm.svelte")
    },
    {
        action: ACTIONS.TEMP_PONS_MANAGE_PROCEDURES,
        component: () => import("./TempPlansOfNursingServices/ManageProcedures/ManageProcedures.svelte")
    },
    {
        action: ACTIONS.WCA_GLOBAL_LIST,
        component: () => import("./WoundCareAssessments/List/WoundCareAssessmentsList.svelte")
    },
    {
        action: ACTIONS.WCA_MANAGE,
        component: () => import("./WoundCareAssessments/Form/WoundCareAssessmentForm.svelte")
    },
    {
        action: ACTIONS.COMPLEX_SEIZURE_SCREENS_GLOBAL_LIST,
        component: () => import("./ComplexSeizureScreening/List/ComplexSeizureScreeningsList.svelte")
    }

];

export default nursingRoutes;